import { IconButton, Tooltip } from '@mui/material';
import CloudOutlinedIcon from '@mui/icons-material/CloudOutlined';
import { useTranslation } from 'react-i18next';
import { getEnvSessionData } from 'components/change-env/change-env.utils';

const EnvIcon = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      title={t('EnvIcon.tooltip')}
      // @ts-ignore
      PopperProps={{ 'data-testid': 'EnvIcon.Tooltip' }}
    >
      <IconButton
        onClick={onClick}
        data-testid="EnvIcon.IconButton"
        color={!!getEnvSessionData() ? 'info' : 'default'}
        size="large"
      >
        <CloudOutlinedIcon />
      </IconButton>
    </Tooltip>
  );
};

export default EnvIcon;
